var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.782 1.19352C11.4759 0.918051 11.0788 0.765625 10.667 0.765625C10.2552 0.765625 9.85804 0.918051 9.55199 1.19352L0.666992 9.19019V17.8569C0.666992 18.5641 0.947944 19.2424 1.44804 19.7425C1.94814 20.2426 2.62641 20.5235 3.33366 20.5235H18.0003C18.7076 20.5235 19.3858 20.2426 19.8859 19.7425C20.386 19.2424 20.667 18.5641 20.667 17.8569V9.19019L11.782 1.19352ZM13.167 18.8544H8.16699V14.666C8.16699 14.003 8.43038 13.3671 8.89922 12.8983C9.36807 12.4294 10.004 12.166 10.667 12.166C11.33 12.166 11.9659 12.4294 12.4348 12.8983C12.9036 13.3671 13.167 14.003 13.167 14.666V18.8544ZM19.0003 17.8544C19.0003 18.1196 18.895 18.3739 18.7074 18.5615C18.5199 18.749 18.2655 18.8544 18.0003 18.8544H14.8337V14.666C14.8337 13.561 14.3947 12.5011 13.6133 11.7197C12.8319 10.9383 11.7721 10.4994 10.667 10.4994C9.56192 10.4994 8.50212 10.9383 7.72071 11.7197C6.93931 12.5011 6.50033 13.561 6.50033 14.666V18.8544H3.33366C3.06844 18.8544 2.81409 18.749 2.62655 18.5615C2.43902 18.3739 2.33366 18.1196 2.33366 17.8544V9.93186L10.667 2.43185L19.0003 9.93186V17.8544Z",
    fill: "#3D3D3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.e53b8e6736d4e3f4ede28fbe2ec856e7.svg";
export { ForwardRef as ReactComponent };